import React from 'react'
import SelectGender from '../templates/SelectGender'
import CardStackHOC from './CardStackHOC'
import RateLookMale from '../templates/RateLookMale'
import RateLookFemale from '../templates/RateLookFemale'
import FemaleSweeps from '../templates/FemaleSweeps'


class SelectGenderHOC extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      gender: '',
      swipeStyle: { transform: 'rotateZ(0deg) translate3d(0, 0, 0)'}
    }
  }

  onNextPage = (gender) => {

    this.setState({gender: gender})

    let path = `/welcome/${gender}`


    if(gender === 'f'){
      path = `/sweeps/f`
    }
        
    this.setState({swipeStyle: { transition: 'transform 400ms, opacity 100ms 200ms', opacity: '0', transform: 'rotateZ(-10deg) translate3d(-100%, 0, 0)'}})
    setTimeout(()=>{ 
      this.props.history.push(path)
      }, 400);

  }


  render () {
    console.log('gender select props', this.props)
    
    if(this.state.gender === 'm'){
      return(
        <CardStackHOC >
          <RateLookMale />
          <SelectGender swipeStyle={this.state.swipeStyle} onNextPage={this.onNextPage} />
        </CardStackHOC>
      )
    }else{
      return(
        <CardStackHOC >
          <FemaleSweeps />
          <SelectGender swipeStyle={this.state.swipeStyle} onNextPage={this.onNextPage} />
        </CardStackHOC>
      )
    }
    
  }
}

export default SelectGenderHOC;



// WEBPACK FOOTER //
// ./src/components/SelectGenderHOC.js